import { useMutationSubmitQuote } from './hooks/useMutationSubmitQuote';
import { useSuspenseQuoteImporterState } from './hooks/useSuspenseQuoteImporterState';
import { QuoteImporterBase } from './QuoteImporterBase';

export function QuoteImporterQuoteRequest(props: {
    quoteRequestId: string;
    returnTo: string;
    onSuccess: (_: { quoteRequestId: string; file: File }) => void;
    onError: () => void;
}): JSX.Element {
    const {
        data: { quoteRequests, defaultQuoteRequest, initialFieldConfiguration },
    } = useSuspenseQuoteImporterState({
        quoteRequestId: props.quoteRequestId,
        defaultFormFieldsConfiguration: {
            // Requirements
            ipn: { visible: true },
            requestedPart: { visible: true },
            partDescription: { visible: true },
            requiredQuantity: { visible: false },
            potentialQuantity: { visible: false },
            recipients: { visible: false },
            targetPrice: { visible: false },
            customerName: { visible: false },

            // Offer
            // bid not visible as this is only relevant for supplier portal
            bid: { visible: false },
            part: { visible: true },
            unitPrice: { visible: true },
            moq: { visible: true },
            mpq: { visible: true },
            currency: { visible: true },
            packaging: { visible: true },
            standardFactoryLeadTime: { visible: true },
            standardFactoryLeadTimeUnit: { visible: true },
            notes: { visible: true },
            ncnr: { visible: true },
            stock: { visible: true },
            supplierPartNumber: { visible: true },
            validFor: { visible: true },
            validFrom: { visible: true },
            validUntil: { visible: true },
            cancellationWindow: { visible: true },
            cancellationTimeUnit: { visible: true },
            itemClass: { visible: true },
            oneTimeCost: { visible: true },

            // Part information
            reach: { visible: true },
            rohs: { visible: true },
            eccnNumbers: { visible: true },
            htsCode: { visible: true },
            countryOfOrigin: { visible: true },
        },
    });

    const { mutateAsync: submitQuote } = useMutationSubmitQuote();

    return (
        <>
            <QuoteImporterBase
                onSuccess={({ quoteRequest, file }) => props.onSuccess({ quoteRequestId: quoteRequest.id, file })}
                onError={props.onError}
                initialFieldConfiguration={initialFieldConfiguration}
                onImport={async (form) => {
                    await submitQuote({ form });
                }}
                quoteRequests={quoteRequests}
                defaultQuoteRequest={defaultQuoteRequest}
                returnTo={props.returnTo}
            />
        </>
    );
}
